import { ApiKeyFields } from "types";

export const defaultValues = {
  [ApiKeyFields.template]: null,
};
